<!-- VIRTUAL CARDS DETAILS -->
<p-dialog
  closeOnEscape="false"
  class="filters-modal"
  [header]="'Detalles de tarjeta - ' + card.alias"
  [modal]="true"
  [(visible)]="showCardDetails"
  [style]="{ width: '850px' }"
  *ngIf="showCardDetails"
  (visibleChange)="exitView()"
  closeOnEscape="false"
>
  <div class="card-information" [ngClass]="'card-brand-' + auth.getCardBrand(card)">
    <div class="card-face">
      <div class="card-PAN-container" [class.is-branded]="isLuxCapitalBrand">
        <div class="card-loading" *ngIf="!isLuxCapitalBrand && !card.PAN">
          <app-loading [loadingText]="'Cargando tarjeta'" />
        </div>

        <div class="branded-card" *ngIf="isLuxCapitalBrand">
          <div class="card-status" *ngIf="card.status == 'FROZEN'">Congelada</div>
          <div class="card-status" *ngIf="card.status == 'DELETED'">Eliminada</div>
          <div class="card-nickname">
            <span *ngIf="card.alias">Alias</span>
            <br />
            {{ card.alias }}
          </div>
          <div class="card-number">{{ displayNumber }}</div>
          <div class="card-holder">
            <span>Cardholder name</span>
            <br />
            {{ card.card_holder_name }}
          </div>
        </div>

        <iframe
          *ngIf="card.PAN && !isLuxCapitalBrand"
          [src]="card.PAN"
          width="100%"
          height="650"
          class="card-PAN"
          allow="clipboard-write"
        ></iframe>
      </div>

      <button
        type="button"
        class="reveal-pan"
        *ngIf="isLuxCapitalBrand && card.PAN"
        (click)="toggleProviderPan()"
      >
        {{ showProviderPan ? 'Ocultar número y CVV' : 'Ver número y CVV' }}
      </button>

      <div class="provider-pan" *ngIf="isLuxCapitalBrand && showProviderPan && card.PAN">
        <iframe
          [src]="card.PAN"
          width="100%"
          height="650"
          class="card-PAN"
          allow="clipboard-write"
        ></iframe>
      </div>
    </div>
    <div class="card-details bigger">
      <div class="card-detail balance">
        <div class="card-title">Balance</div>
        <div class="card-value" *ngIf="!loadingCardBalance">
          $ {{ card.balance ? (card.balance | number: "1.2-8") : "0.00" }}
          <div
            class="add-balance"
            [class.disabled]="!auth.canPerformTransactionalActions()"
            [pTooltip]="auth.canPerformTransactionalActions() ? 'Agregar saldo' : auth.getComplianceBlockedMessage()"
            tooltipPosition="right"
            *ngIf="card.wallets"
            (click)="toggleWallets()"
          >
            <i class="pi pi-plus"></i>
          </div>
        </div>
        <div class="card-value" *ngIf="loadingCardBalance">
          <i class="pi pi-spin pi-spinner" style="font-size: 24px"></i>
        </div>
      </div>
      <div class="card-detail">
        <div class="card-title">Estatus</div>
        <div
          class="card-value status"
          [class.processing]="card.status === 'FROZEN'"
          [class.finished]="card.status === 'ACTIVE'"
          [class.cancelled]="card.status === 'DELETED'"
        >
          <span *ngIf="card.status === 'ACTIVE'"> Activa </span>
          <span *ngIf="card.status === 'FROZEN'"> Congelada </span>
          <span *ngIf="card.status === 'DELETED'"> Eliminada </span>
        </div>
      </div>
    </div>
    <div class="card-details">
      <div class="card-detail">
        <div class="card-title">Límite diario</div>
        <div class="card-value" *ngIf="card.weekly_limit">
          $ {{ card.daily_limit | number: "1.2-10" }}
        </div>
        <div class="card-value" *ngIf="!card.weekly_limit">N/A</div>
      </div>
      <div class="card-detail">
        <div class="card-title">Límite semanal</div>
        <div class="card-value" *ngIf="card.weekly_limit">
          $ {{ card.weekly_limit | number: "1.2-10" }}
        </div>
        <div class="card-value" *ngIf="!card.weekly_limit">N/A</div>
      </div>
      <div class="card-detail">
        <div class="card-title">Límite mensual</div>
        <div class="card-value" *ngIf="card.monthly_limit">
          $ {{ card.monthly_limit | number: "1.2-10" }}
        </div>
        <div class="card-value" *ngIf="!card.monthly_limit">N/A</div>
      </div>
    </div>
  </div>
  <div class="buttons-container">
    <p-button label="Salir" severity="danger" (click)="exitView()" />
    <p-button
      label="Ver transacciones"
      severity="secondary"
      (click)="openTransactions()"
    />

    <ng-container *appHasPlatformService="'virtual-card:manage'">
      <p-button
        *ngIf="card.PAN && card.status !== 'DELETED'"
        [label]="
          card.status == 'ACTIVE' ? 'Congelar tarjeta' : 'Descongelar tarjeta'
        "
        [disabled]="updatingCard"
        [loading]="updatingCard"
        severity="secondary"
        (click)="confirmFreezeCard($event)"
      />
      <p-button
        *ngIf="card.status === 'ACTIVE'"
        label="Recargar tarjeta"
        severity="secondary"
        (click)="openRechargeCard()"
      />
      <p-button
        *ngIf="card.wallets"
        label="Depositar crypto"
        severity="secondary"
        (click)="toggleWallets()"
      />
    </ng-container>
  </div>
</p-dialog>

<p-dialog
  closeOnEscape="false"
  class="filters-modal"
  header="Recargar tarjeta"
  [modal]="true"
  [(visible)]="showRechargeCard"
  [style]="{ width: '520px' }"
  *ngIf="showRechargeCard"
  (visibleChange)="closeRechargeCard()"
>
  <div class="filters-container">
    <div class="loading-add-card" *ngIf="rechargingCard">
      <app-loading [loadingText]="'Recargando tu tarjeta'" />
    </div>
    <form class="form-container" [formGroup]="rechargeForm">
      <div class="input-item">
        <label for="recharge_amount">Monto a recargar (USDT)</label>
        <p-inputNumber
          inputId="recharge_amount"
          formControlName="amount"
          mode="decimal"
          [min]="0"
          [minFractionDigits]="2"
          [maxFractionDigits]="8"
          placeholder="0.00"
          [style]="{ width: '100%' }"
          (onInput)="onRechargeAmountChange($event.value)"
          (onBlur)="onRechargeAmountChange()"
        />
      </div>
      <div class="input-item">
        <label for="recharge_wallet_id">Wallet USDT</label>
        <p-dropdown
          inputId="recharge_wallet_id"
          placeholder="Elige la wallet desde la que se debitará el monto"
          formControlName="wallet_id"
          [options]="rechargeWallets"
          optionLabel="wallet_shortname"
          [filter]="true"
          filterBy="wallet_shortname,shortname,id"
          [style]="{ width: '100%' }"
          appendTo="body"
          [disabled]="loadingRechargeWallets"
        />
      </div>
      <div class="card-fee-summary">
        <small class="p-text-secondary" *ngIf="loadingRechargeFee">
          Calculando monto de recarga...
        </small>
        <small class="card-fee-error" *ngIf="rechargeFeeError">
          {{ rechargeFeeError }}
        </small>
        <ng-container *ngIf="!loadingRechargeFee && !rechargeFeeError && rechargeFee">
          <div class="card-fee-row">
            <span>Monto</span>
            <strong>{{ formattedRechargeAmount(rechargeFee.amount) }}</strong>
          </div>
          <div class="card-fee-row card-fee-total">
            <span>Se envía a la tarjeta</span>
            <strong>{{ formattedRechargeAmount(rechargeFee.net_amount) }}</strong>
          </div>
        </ng-container>
      </div>
    </form>
    <div class="disclaimer">
      Elegí cuánto recargar desde el saldo BitGo; el resto queda en la wallet.
      TransferSwap no cobra fee de recarga: se envía el monto completo a
      CryptoMate y la tarjeta se acredita cuando confirme la red.
    </div>
  </div>
  <div class="buttons-container">
    <p-button label="Cancelar" severity="danger" (click)="closeRechargeCard()" />
    <p-button
      label="Recargar"
      [disabled]="!canSubmitRecharge()"
      [loading]="rechargingCard"
      severity="secondary"
      (click)="confirmRechargeCard($event)"
    />
  </div>
</p-dialog>
